module.exports = __webpack_public_path__ + "static/img/s4.90fb11a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/s4.png
// module id = Alk1
// module chunks = 0